import { initializeApp } from '@firebase/app';
import { getFirestore } from '@firebase/firestore';
import { getStorage } from '@firebase/storage'
import { getAuth } from "firebase/auth";


const firebaseConfig = {
    apiKey: "AIzaSyCnyNDVtxUIRAVyERYFado0snN6bmBVLhI",
    authDomain: "arcaentretenimento.firebaseapp.com",
    projectId: "arcaentretenimento",
    storageBucket: "arcaentretenimento.appspot.com",
    messagingSenderId: "885067285835",
    appId: "1:885067285835:web:93d535de45a8138350d4ce"
  };

const app = initializeApp(firebaseConfig)
export const db = getFirestore()
export const storage = getStorage(app)
export const auth = getAuth(app)